export type ThemeConfig = {
  /** The list of available themes. */
  readonly themes: ReadonlyArray<{
    /** The unique identifier used for persistence and selection. */
    readonly id: string;
    /** The human-readable display name shown in the UI. */
    readonly name: string;
  }>;
  /** The list of theme regions and their variables. */
  readonly regions: Record<
    string,
    ReadonlyArray<{
      /** Storage key used in custom overrides (e.g. `'sidebarBg'`). */
      readonly key: string;
      /** The CSS custom property name (e.g. `'--sidebar-bg'`). */
      readonly cssVar: string;
      /** Human-readable label shown in the custom theme editor. */
      readonly label: string;
    }>
  >;
};

export const themeConfig = {
  themes: [
    { id: 'default', name: 'Default' },
    { id: 'charcoal', name: 'Charcoal' },
    { id: 'slate', name: 'Slate' },
    { id: 'navy', name: 'Navy' },
    { id: 'lavender', name: 'Lavender' },
    { id: 'monokai', name: 'Monokai' },
    { id: 'solarized', name: 'Solarized' },
    { id: 'classic', name: 'Classic' },
  ],
  regions: {
    Sidebar: [
      { key: 'sidebarBg', cssVar: '--sidebar-bg', label: 'Background' },
      {
        key: 'sidebarBgSecondary',
        cssVar: '--sidebar-bg-secondary',
        label: 'Background secondary',
      },
      {
        key: 'sidebarBorderColor',
        cssVar: '--sidebar-border-color',
        label: 'Border',
      },
      {
        key: 'sidebarTextColor',
        cssVar: '--sidebar-text-color',
        label: 'Text',
      },
      {
        key: 'sidebarTextColorSecondary',
        cssVar: '--sidebar-text-color-secondary',
        label: 'Text secondary',
      },
      {
        key: 'sidebarNotificationColor',
        cssVar: '--sidebar-notification-color',
        label: 'Notifications',
      },
    ],
  },
} as const satisfies ThemeConfig;
